<section class="cliente-man-shell">
  <header class="cliente-man-hero">
    <div>
      <h2 class="cliente-man-title">{{ isEditMode ? 'Editar Cliente' : 'Novo Cliente' }}</h2>
      <p class="cliente-man-subtitle">Preencha os dados cadastrais do cliente.</p>
    </div>
    <span class="cliente-man-chip">{{ isEditMode ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form [formGroup]="clienteForm" (ngSubmit)="salvarCliente()" id="clienteForm" class="cliente-man-card">
    <div class="form-section">
      <h3>Dados Gerais</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="nomeRazaoSocial" class="form-label">*Nome/Razão Social</label>
          <input type="text" id="nomeRazaoSocial" formControlName="nomeRazaoSocial" class="form-control"
            [ngClass]="{ 'is-invalid': clienteForm.get('nomeRazaoSocial')?.invalid && clienteForm.get('nomeRazaoSocial')?.touched }">
          <div *ngIf="clienteForm.get('nomeRazaoSocial')?.invalid && clienteForm.get('nomeRazaoSocial')?.touched" class="invalid-feedback">
            Nome/Razão Social é obrigatório.
          </div>
        </div>

        <div class="col-md-6">
          <label for="nomeFantasia" class="form-label">Nome Fantasia</label>
          <input type="text" id="nomeFantasia" formControlName="nomeFantasia" class="form-control">
        </div>

        <div class="col-md-6">
          <label for="cpfCnpj" class="form-label">* CPF/CNPJ</label>
          <input
            type="text"
            id="cpfCnpj"
            formControlName="cpfCnpj"
            class="form-control"
            mask="000.000.000-00||00.000.000/0000-00"
            [showMaskTyped]="false"
            [dropSpecialCharacters]="false"
            [ngClass]="{ 'is-invalid': clienteForm.get('cpfCnpj')?.invalid && clienteForm.get('cpfCnpj')?.touched }"
          >
          @if (clienteForm.get('cpfCnpj')?.invalid && clienteForm.get('cpfCnpj')?.touched) {
            <div class="invalid-feedback">
              @if (clienteForm.get('cpfCnpj')?.errors?.['required']) {
                CPF/CNPJ é obrigatório.
              }
              @if (clienteForm.get('cpfCnpj')?.errors?.['mask']) {
                Documento inválido.
              }
            </div>
          }
        </div>

        <div class="col-md-6">
          <label for="uf" class="form-label">UF</label>
          <select id="uf" formControlName="uf" class="form-control">
            <option *ngFor="let uf of ufs" [value]="uf">{{ uf }}</option>
          </select>
        </div>

        <div class="col-md-6">
          <label for="pais" class="form-label">País</label>
          <input type="text" id="pais" formControlName="pais" class="form-control">
        </div>

        <div class="col-md-6">
          <label for="municipio" class="form-label">Município</label>
          <input type="text" id="municipio" formControlName="municipio" class="form-control">
        </div>
      </div>
    </div>

    <div class="form-section">
      <h3>Contato e Complemento</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="email" class="form-label">Email</label>
          <input type="email" id="email" formControlName="email" class="form-control"
            [ngClass]="{ 'is-invalid': clienteForm.get('email')?.touched && clienteForm.get('email')?.errors?.['email'] }">
          <div *ngIf="clienteForm.get('email')?.touched && clienteForm.get('email')?.errors?.['email']" class="invalid-feedback">
            Formato de email inválido.
          </div>
        </div>

        <div class="col-md-6">
          <label for="telefone" class="form-label">*Telefone</label>
          <input type="text" id="telefone" formControlName="telefone" class="form-control" mask="(00) 00000-0000"
            [ngClass]="{ 'is-invalid': clienteForm.get('telefone')?.invalid && clienteForm.get('telefone')?.touched }">
          <div *ngIf="clienteForm.get('telefone')?.invalid && clienteForm.get('telefone')?.touched" class="invalid-feedback">
            Telefone é obrigatório.
          </div>
        </div>

        <div class="col-md-6">
          <label for="telefone2" class="form-label">Telefone 2</label>
          <input type="text" id="telefone2" formControlName="telefone2" class="form-control" mask="(00) 00000-0000">
        </div>

        <div class="col-md-6">
          <label for="endereco" class="form-label">Endereço</label>
          <input type="" id="endereco" formControlName="endereco" class="form-control">
        </div>

        <div class="col-md-6">
          <div class="form-check mt-2">
            <input class="form-check-input" type="checkbox" id="restricaoAtiva" formControlName="restricaoAtiva">
            <label class="form-check-label" for="restricaoAtiva">
              Restrição Ativa
            </label>
          </div>
        </div>

        <div class="col-md-12">
          <label for="observacao" class="form-label">Observações</label>
          <textarea id="observacao" formControlName="observacao" class="form-control" rows="3"></textarea>
        </div>
      </div>
    </div>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="cancelar()">Cancelar</button>
    <button type="submit" form="clienteForm" class="btn btn-primary">Salvar</button>
  </footer>
</section>
